<div class="grid__item grid__item--{span} {class}">

    <slot></slot>

</div>

<style>
    @media screen and (min-width: 80rem) {
        .grid__item {
            flex: 0 auto;
        }

        .grid__item--1-of-12 {
            width: calc(100% / 12);
        }

        .grid__item--2-of-12 {
            width: calc(100% / 12 * 2);
        }

        .grid__item--3-of-12 {
            width: calc(100% / 12 * 3);
        }

        .grid__item--4-of-12 {
            width: calc(100% / 12 * 4);
        }

        .grid__item--5-of-12 {
            width: calc(100% / 12 * 5);
        }

        .grid__item--6-of-12 {
            width: calc(100% / 12 * 6);
        }

        .grid__item--7-of-12 {
            width: calc(100% / 12 * 7);
        }

        .grid__item--8-of-12 {
            width: calc(100% / 12 * 8);
        }

        .grid__item--9-of-12 {
            width: calc(100% / 12 * 9);
        }

        .grid__item--10-of-12 {
            width: calc(100% / 12 * 10);
        }

        .grid__item--11-of-12 {
            width: calc(100% / 12 * 11);
        }

        .grid__item--12-of-12 {
            width: 100%;
        }
    }    
</style>

<script>
    export default {
        data() {
            return {
                span: '12-of-12',
                class: ''
            }
        }
    }
</script>